import * as React from "react";
import SW, { ReactSwitchProps } from "react-switch";;
import { Col } from "reactstrap";
import './switch.css'
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //Wrapped Switch//////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface ISwitchProps {
    labelText: string;
}
type ISWProps = ReactSwitchProps & ISwitchProps;
const style = {
    onColor: '#B0DE00',
    onHandleColor: "#ffffff",
    handleDiameter: 20,
    uncheckedIcon: false,
    checkedIcon: false,
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.6)",
    activeBoxShadow: "0px 0px 1px 10px rgba(0, 0, 0, 0.2)",
    height: 20,
    className: "switcher",
    width: 38
}
export const Switch = (props: ISWProps) => {
    return (
        <label className="switch"  htmlFor="normal-switch">
            <SW {...style} {...props} />
            <span className="labelSwitch">{props.labelText}</span>
        </label>
    );
}
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //Wrapped Switch//////////////////////////////////////////////////////////////////////////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface IWrappedProps {
    md: number | string;
}
type WrappedInputProps = ReactSwitchProps & ISwitchProps & IWrappedProps;
export const WrappedSwitch = (props: WrappedInputProps) => {
    const switchProps = { ...props };
    delete switchProps.md;
    return (
        <Col md={props.md} >
            <Switch {...switchProps} />
        </Col>
    )
}


// WEBPACK FOOTER //
// ./src/share/components/Switch/Switch.tsx